import { t } from "i18next";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { GetUserLicenseStart } from "../../../user/UserActions";
import styles from "./EditLicense.module.css";

export default function EditLicense() {
    const dispatch = useDispatch();

    // プロジェクトパラメータ
    const { userLicense } = useSelector((state: AppState) => ({
        userLicense: state.user.userLicense,
    }));

    // APIコール
    useEffect(() => {
        dispatch(GetUserLicenseStart(window.location.host));
        // eslint-disable-next-line
    }, []);

    return (
        <div className={styles.infoDiv}>
            <div className={styles.title}>
                {t("契約中のライセンス数：")}
                {userLicense && userLicense.licenses}
            </div>
            <div className={styles.title}>
                {t("アクティブユーザー数：")}
                {userLicense && userLicense.activeUsers}
            </div>
        </div>
    );
}
